<!-- <input #textbox type="text" maxlength="textLength ? textLength : 64"
  class="pin-input" style="width: 50%; margin:auto" [(ngModel)]="textValue" [min]="min" [max]="max" appValidateNumber/> -->
<input #textbox type="text" maxlength="textLength ? textLength : 64"
  class="pin-input" [(ngModel)]="textValue" [min]="min" [max]="max"/><span></span>

<on-screen-keyboard class="pin-keyboard" [customLayout]="layout" (keyPress)="keyPress($event)"></on-screen-keyboard>
